const state = {
  sidebar: {
    visible: true
  }
};

const getters = {
  visible: state => {
    return state.sidebar.visible;
  }
};

const actions = {
  toggle: ({ commit }) => {
    commit("setVisible");
  }
};

const mutations = {
  setVisible: state => {
    state.sidebar.visible = !state.sidebar.visible;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
